imat.namespace("imat.utils").Cookie = function () {

    function _get(cookieName) {
        var result = new Array();
        var cookieValue = $.cookie(cookieName);
        if (cookieValue == null) {
            return null;
        };
        if (cookieValue.indexOf("=") === -1) {
            return cookieValue;
        };
        var keyValuePairs = cookieValue.split("&");
        for (var i = 0, length = keyValuePairs.length ; i < length; i++) {
            var keyValuePair = keyValuePairs[i].split('=');
            result.push({
                key: keyValuePair[0],
                value: keyValuePair[1]
            });
        };
        return result;
    };

    function _set(cookieName, keyValueArray, expiresIn) {
        var cookieValue = '';
        for (var i = 0, length = keyValueArray.length; i < length; i++) {
            cookieValue += keyValueArray[i].key + '=' + keyValueArray[i].value + '&';
        };
        cookieValue = cookieValue.substr(0, cookieValue.length - 1);
        $.cookie(cookieName, cookieValue, { expires: expiresIn, path: '/' });
    };

    return {
        get: _get,
        set: _set
    };
}();

imat.namespace("imat.utils").NumberFilter = function () {
    
    function _numberFilter(e, regex) {
        var keyNum;
        var keyChar;

        keyNum = e.keyCode ? e.keyCode : e.which;

        keyChar = String.fromCharCode(keyNum);
        if (keyNum === 35/*end*/
            || keyNum === 36/*home*/
            || keyNum === 37/*left*/
            || keyNum === 39/*right*/) {
            return true;
        }
        if (regex.test(keyChar)) {
            if (keyChar == '.' && $(this).val().indexOf('.') >= 0) {
                return false;
            }
            return true;
        } else if (keyChar == "\n" || keyChar == "\r") {
            //Do this to prevent submitting form on Enter
            $(this).change();
            return false;
        } else {
            return false;
        }
    }

    return {
        DoubleNumberFilter: function(e) { return _numberFilter(e, /[\d\.\x08]/); },
        IntegerNumberFilter: function(e) { return _numberFilter(e, /[\d\x08]/); }
    };
};

imat.namespace("imat.utils").Cache = function () {
    var data = {};

    var _getData = function (key) {
        return data[key];
    };

    var _containsData = function (key) {
        var result = false;
        if (data.hasOwnProperty(key) && data[key] !== undefined) {
            result = true;
        }
        return result;
    };

    var _clear = function () {
        data = {};
    };

    var _addData = function (key, value) {
        data[key] = value;
    };

    return {
        getData: _getData,
        containsData: _containsData,
        clear: _clear,
        addData: _addData
    };
}

function formatPrice(value, currencySymbol) {
    var newValue = value;
    if (typeof (value.toFixed) === 'function') {
        newValue = value.toFixed(2);

        if (currencySymbol === "¥") {
            newValue = parseInt(newValue, 10);
        }
    }
    if (currencySymbol === "€") {
        return newValue + " " + currencySymbol;
    }
    return currencySymbol + " " + newValue;
}

function getFileNameFromUrl(data) {
    return data.match(/(.*)[\/\\]([^\/\\]+)\.\w+$/)[2];
}

function isHtmlBodyValid(value) {
    var scriptsRegExp = /(<[ ]*[sS][cC][rR][iI][pP][tT])|(<[a-zA-Z ][^>]*\s[oO][nN][\w ]+=([\w+ ]|'[^']*'|"[^"]*")[^>]*>)|([hH][rR][eE][fF][ ]*=['" ]*[jJ][aA][vV][aA][sS][cC][rR][iI][pP][tT][ ]*:)/;
    return value.match(scriptsRegExp) == null;
}

function redirectTo(to) {
    window.location = to
}

Boolean.parse = function (boolString) {
    if (boolString == null) {
        return false;
    };
    return boolString.toString().toLowerCase() === "true";
};

String.prototype.trim = function () {
    return this.replace(/(^\s+)|(\s+$)/g, "");
}

String.isNotValidHtml = function (value) {
    var reg = /[\<\>]+/;
    return !(value.match(reg));
}

$.extend({
    getUrlVars: function () {
        var vars = [], hash;
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for (var i = 0; i < hashes.length; i++) {
            hash = hashes[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
        }
        return vars;
    },

    getUrlVar: function (name) {
        return $.getUrlVars()[name];
    }
});